import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { PORTAL_SECTIONS, usePortalAccess } from './PortalAccess';

export default function PortalNavigation({ onNavigate }) {
  const { permissions } = usePortalAccess();
  const location = useLocation();
  const [open, setOpen] = useState({ helpdesk: true });
  useEffect(() => {
    const section = PORTAL_SECTIONS.find(s => s.items.some(([, path]) => location.pathname.startsWith(path.split('?')[0])));
    if (section) setOpen(previous => ({ ...previous, [section.id]: true }));
  }, [location.pathname]);
  return <nav className="sidebar-nav" onClick={onNavigate}>
    {PORTAL_SECTIONS.map(section => {
      const items = section.items.filter(([key]) => permissions[key]);
      if (!items.length) return null;
      return <div className="nav-section" key={section.id}>
        <button type="button" className="nav-section-toggle" aria-expanded={!!open[section.id]} aria-controls={`nav-${section.id}`} onClick={() => setOpen(previous => ({ ...previous, [section.id]: !previous[section.id] }))}>
          <span>{section.label}</span><span className={`nav-chevron ${open[section.id] ? '' : 'closed'}`}>›</span>
        </button>
        {open[section.id] && <div className="nav-section-items" id={`nav-${section.id}`}>
          {items.map(([key, path, label]) => <NavLink key={key} to={path} className={({ isActive }) => 'nav-item' + (isActive && (!path.includes('?') || location.search === path.slice(path.indexOf('?'))) ? ' active' : '')}>{label}</NavLink>)}
        </div>}
      </div>;
    })}
  </nav>;
}
